import PropTypes from "prop-types";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { RED } from "assets/theme/brandColors";

function UnitToggle({ metric, onChange }) {
  return (
    <Box
      onClick={onChange}
      sx={{
        display: "inline-flex",
        alignItems: "center",
        bgcolor: "#f0f0f0",
        borderRadius: 20,
        p: "3px",
        cursor: "pointer",
        userSelect: "none",
        gap: 0,
      }}
    >
      {["US", "Metric"].map((label) => {
        const active = (label === "Metric") === metric;
        return (
          <Box
            key={label}
            sx={{
              px: 1.5,
              py: 0.4,
              borderRadius: 20,
              bgcolor: active ? RED : "transparent",
              transition: "background 0.2s",
            }}
          >
            <Typography
              sx={{
                fontSize: 12,
                fontWeight: 600,
                color: active ? "#fff" : "#888",
                transition: "color 0.2s",
                lineHeight: 1.4,
              }}
            >
              {label}
            </Typography>
          </Box>
        );
      })}
    </Box>
  );
}

UnitToggle.propTypes = {
  metric: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired,
};

export default UnitToggle;
